"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConflictResolver = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _collisionWording = require("@common/components/remedy/collision-wording");
var _cardCollisions = require("@common/utils/redline/text/card-collisions");
var _wordTokenizer = require("@common/utils/redline/text/word-tokenizer");
var _tableOperations = require("@common/utils/redline/table-operations");
var _utils = require("@design/lib/utils");
var _AnalyticsContext = require("../../../context/AnalyticsContext");
var _cardLiveProposal = require("../proposal-card/card-live-proposal");
var _CardLiveChange = require("../proposal-card/CardLiveChange");
var _trackerTypes = require("./tracker-types");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CONTEXT_WORDS_AROUND_ZONE = 8;
var optionButtonClass = function optionButtonClass(isSelected) {
  return (0, _utils.cn)("w-full text-left flex items-start gap-2 px-2 py-1.5 rounded border text-[11px] cursor-pointer bg-white disabled:cursor-not-allowed disabled:opacity-60", isSelected ? "border-primary bg-background-primary-canvas" : "border-[#E5E2DD] hover:border-border-primary-subtle");
};
var primaryButtonClass = "flex items-center gap-1 px-3 h-[22px] rounded text-[11px] text-white bg-primary border-none cursor-pointer disabled:bg-[#B0B0B0] disabled:cursor-not-allowed";
function zoneContextOf(baseText, zone) {
  var units = _wordTokenizer.WordTokenizer.diffUnitsWithTrailingSeparators(baseText);
  var firstUnitShown = Math.max(0, zone.zoneStartWordIndex - CONTEXT_WORDS_AROUND_ZONE);
  var lastUnitShown = Math.min(units.length, zone.zoneEndWordIndex + CONTEXT_WORDS_AROUND_ZONE);
  var beforeStart = zone.zoneStartWordIndex > 0 ? Math.min(units[firstUnitShown].startOffset, zone.startOffset) : zone.startOffset;
  var afterEnd = lastUnitShown > zone.zoneEndWordIndex ? Math.max(units[lastUnitShown - 1].endOffset, zone.endOffset) : zone.endOffset;
  return {
    before: baseText.slice(beforeStart, zone.startOffset),
    zoneStretch: baseText.slice(zone.startOffset, zone.endOffset),
    after: baseText.slice(zone.endOffset, afterEnd),
    textLeftOutBefore: firstUnitShown > 0,
    textLeftOutAfter: lastUnitShown < units.length
  };
}
function spacingAtZoneOf(baseText, zone) {
  var _exec$, _exec, _exec$2, _exec2;
  var spacingAfter = (_exec$ = (_exec = /^\s*/.exec(baseText.slice(zone.endOffset))) === null || _exec === void 0 ? void 0 : _exec[0]) !== null && _exec$ !== void 0 ? _exec$ : "";
  if (zone.endOffset < baseText.length) return spacingAfter;
  return (_exec$2 = (_exec2 = /\s*$/.exec(baseText.slice(0, zone.startOffset))) === null || _exec2 === void 0 ? void 0 : _exec2[0]) !== null && _exec$2 !== void 0 ? _exec$2 : "";
}
var ConflictResolver = exports.ConflictResolver = function ConflictResolver(_ref) {
  var _cards$map$find$autho, _cards$map$find;
  var conflict = _ref.conflict,
    isApplying = _ref.isApplying,
    previewOf = _ref.previewOf,
    signedInAuthorName = _ref.signedInAuthorName,
    onBack = _ref.onBack,
    onApply = _ref.onApply;
  var group = conflict.group,
    cards = conflict.cards;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var openZones = group.openZoneIndexes.map(function (zoneIndex) {
    return group.zoning.zones[zoneIndex];
  });
  var isSinglePart = openZones.length === 1;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    stepIndex = _useState2[0],
    setStepIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return openZones.map(function () {
        return null;
      });
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    decisions = _useState4[0],
    setDecisions = _useState4[1];
  var isReviewStep = stepIndex === openZones.length;
  var currentZone = isReviewStep ? null : openZones[stepIndex];
  var currentDecision = isReviewStep ? null : decisions[stepIndex];
  var cardOf = function cardOf(cardId) {
    return cards.find(function (card) {
      return card.actionId === cardId;
    });
  };
  function decidedTextOf(zone, decision) {
    var _zone$options$find$op, _zone$options$find;
    if (decision.kind === "original") return zone.originalText;
    if (decision.kind === "custom") return decision.text;
    return (_zone$options$find$op = (_zone$options$find = zone.options.find(function (option) {
      return option.cardId === decision.cardId;
    })) === null || _zone$options$find === void 0 ? void 0 : _zone$options$find.optionText) !== null && _zone$options$find$op !== void 0 ? _zone$options$find$op : zone.originalText;
  }
  function composedTextWith(decisionsToUse) {
    return (0, _cardCollisions.composeParagraphText)(group.baseText, group.zoning.uncontestedChanges, group.zoning.zones.map(function (zone, zoneIndex) {
      var _settledZoneText;
      var openPosition = group.openZoneIndexes.indexOf(zoneIndex);
      if (openPosition === -1) return {
        zone: zone,
        chosenText: (_settledZoneText = (0, _cardCollisions.settledZoneText)(zone, group.cardsChanges, group.baseText)) !== null && _settledZoneText !== void 0 ? _settledZoneText : zone.originalText
      };
      var decision = decisionsToUse[openPosition];
      return {
        zone: zone,
        chosenText: decision === null ? zone.originalText : decidedTextOf(zone, decision)
      };
    }));
  }
  var everyZoneDecided = decisions.every(function (decision) {
    return decision !== null;
  });
  var composedText = isReviewStep ? composedTextWith(decisions) : null;
  var resolutionAuthor = (_cards$map$find$autho = (_cards$map$find = cards.map(_trackerTypes.textRedlineOfTrackerCard).find(function (textRedline) {
    return textRedline !== null;
  })) === null || _cards$map$find === void 0 ? void 0 : _cards$map$find.author) !== null && _cards$map$find$autho !== void 0 ? _cards$map$find$autho : "";
  var resolutionPreview = (0, _react.useMemo)(function () {
    if (composedText === null) return null;
    try {
      return (0, _cardLiveProposal.cardLivePreviewOf)({
        markup: "",
        textRedline: {
          author: resolutionAuthor,
          paragraphs: [{
            bookmark: group.bookmark,
            textWhenProposed: group.baseText,
            textProposed: composedText
          }],
          insertions: [],
          tableChanges: _tableOperations.NO_TABLE_CHANGES,
          cardKind: "paragraphs",
          reverts: []
        },
        bookmarks: [group.bookmark],
        afterBookmarks: [],
        edit: null
      });
    } catch (error) {
      sendError(error instanceof Error ? error : new Error(String(error)), {
        component: "ConflictResolver",
        action: "preview_resolution",
        bookmark: group.bookmark
      });
      return null;
    }
  }, [composedText, resolutionAuthor, group.bookmark, group.baseText, sendError]);
  var choose = function choose(decision) {
    var nextDecisions = decisions.map(function (existing, position) {
      return position === stepIndex ? decision : existing;
    });
    setDecisions(nextDecisions);
    if (isSinglePart && decision.kind !== "custom") onApply(composedTextWith(nextDecisions), [decision]);
  };
  var applyAll = function applyAll() {
    onApply(composedTextWith(decisions), decisions.filter(function (decision) {
      return decision !== null;
    }));
  };
  var goBack = function goBack() {
    if (stepIndex === 0) onBack();else setStepIndex(stepIndex - 1);
  };
  var header = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex-shrink-0 flex items-center gap-2 pb-1.5 border-b border-[#E5E2DD]",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      onClick: onBack,
      className: "flex items-center gap-1 text-[11px] text-primary bg-transparent border-none p-0 cursor-pointer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
        width: 12,
        height: 12
      }), "All redlines"]
    })
  });
  function renderCardChange(cardId, applied) {
    var preview = previewOf(cardId);
    return preview === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLiveChange.CardLiveChange, {
      preview: preview,
      signedInAuthorName: signedInAuthorName,
      blockLimit: _cardLiveProposal.CARD_EXCERPT_BLOCK_LIMIT,
      applied: applied,
      "data-sentry-element": "CardLiveChange",
      "data-sentry-component": "renderCardChange",
      "data-sentry-source-file": "ConflictResolver.tsx"
    });
  }
  function renderZoneContext(zone) {
    var context = zoneContextOf(group.baseText, zone);
    var zoneMark = context.zoneStretch.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "bg-[#FEF3C7] text-[#92400E] px-0.5 rounded",
      children: context.zoneStretch
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "bg-[#FEF3C7] text-[#92400E] px-1 rounded",
      children: "\u25BE"
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-zone-context": true,
      className: "text-[11px] leading-[16px] text-[#4a5568] bg-[#F8F6F3] border border-[#E5E2DD] rounded px-2 py-1.5 whitespace-pre-wrap",
      "data-sentry-component": "renderZoneContext",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: [context.textLeftOutBefore && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#9A9896]",
        children: "\u2026"
      }), context.before, zoneMark, context.after, context.textLeftOutAfter && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#9A9896]",
        children: "\u2026"
      })]
    });
  }
  function renderCardOption(cardId) {
    var _cardOf$cardNumber, _cardOf;
    var isSelected = (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) === "card" && currentDecision.cardId === cardId;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      disabled: isApplying,
      onClick: function onClick() {
        return choose({
          kind: "card",
          cardId: cardId
        });
      },
      className: optionButtonClass(isSelected),
      "data-sentry-component": "renderCardOption",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "font-semibold text-primary flex-shrink-0",
        children: ["#", (_cardOf$cardNumber = (_cardOf = cardOf(cardId)) === null || _cardOf === void 0 ? void 0 : _cardOf.cardNumber) !== null && _cardOf$cardNumber !== void 0 ? _cardOf$cardNumber : "?"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "flex-1 min-w-0",
        children: renderCardChange(cardId, false)
      })]
    }, cardId);
  }
  function renderOriginalOption(zone) {
    var isSelected = (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) === "original";
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      disabled: isApplying,
      onClick: function onClick() {
        return choose({
          kind: "original"
        });
      },
      className: optionButtonClass(isSelected),
      "data-sentry-component": "renderOriginalOption",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#686766]",
        children: zone.originalText ? "Neither: keep \"".concat(zone.originalText, "\"") : "Neither: add nothing here"
      })
    });
  }
  function renderAppliedOption(cardId) {
    var _cardOf$supersededBy, _cardOf2, _cardOf$cardNumber2, _cardOf3;
    var supersededBy = (_cardOf$supersededBy = (_cardOf2 = cardOf(cardId)) === null || _cardOf2 === void 0 ? void 0 : _cardOf2.supersededBy) !== null && _cardOf$supersededBy !== void 0 ? _cardOf$supersededBy : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "w-full flex items-start gap-2 px-2 py-1.5 rounded border border-[#E5E2DD] bg-[#F8F6F3] text-[11px]",
      "data-sentry-component": "renderAppliedOption",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "font-semibold text-[#166534] flex-shrink-0",
        children: ["#", (_cardOf$cardNumber2 = (_cardOf3 = cardOf(cardId)) === null || _cardOf3 === void 0 ? void 0 : _cardOf3.cardNumber) !== null && _cardOf$cardNumber2 !== void 0 ? _cardOf$cardNumber2 : "?"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-0.5 flex-shrink-0 text-[10px] text-[#166534] font-medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 11,
          height: 11,
          "data-sentry-element": "CheckIcon",
          "data-sentry-source-file": "ConflictResolver.tsx"
        }), supersededBy === null ? "Applied here" : "Superseded by ".concat(supersededBy)]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "flex-1 min-w-0",
        children: renderCardChange(cardId, true)
      })]
    }, cardId);
  }
  function renderCombineOption(zone) {
    var pendingOptions = zone.options.filter(function (option) {
      var _cardOf4;
      return !((_cardOf4 = cardOf(option.cardId)) !== null && _cardOf4 !== void 0 && _cardOf4.isApplied) && option.removesRow !== true;
    });
    if (pendingOptions.length < 2) return null;
    var cardNumbers = pendingOptions.map(function (option) {
      var _cardOf$cardNumber3, _cardOf5;
      return (_cardOf$cardNumber3 = (_cardOf5 = cardOf(option.cardId)) === null || _cardOf5 === void 0 ? void 0 : _cardOf5.cardNumber) !== null && _cardOf$cardNumber3 !== void 0 ? _cardOf$cardNumber3 : 0;
    });
    var combinedText = pendingOptions.map(function (option) {
      return option.optionText;
    }).join(spacingAtZoneOf(group.baseText, zone));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      disabled: isApplying,
      onClick: function onClick() {
        return choose({
          kind: "custom",
          text: combinedText
        });
      },
      className: optionButtonClass(false),
      "data-sentry-component": "renderCombineOption",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-[#686766]",
        children: ["Use ", (0, _collisionWording.joinedCardNumbersOf)(cardNumbers), " together, then edit"]
      })
    });
  }
  function renderCustomOption(zone) {
    var isSelected = (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) === "custom";
    var startingText = currentDecision === null ? zone.originalText : decidedTextOf(zone, currentDecision);
    var customEditor = (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) === "custom" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      value: currentDecision.text,
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      onChange: function onChange(event) {
        return choose({
          kind: "custom",
          text: event.target.value
        });
      },
      rows: 2,
      className: "w-full mt-1 text-[11px] border border-[#D4D3D0] rounded px-1.5 py-1 resize-y",
      autoFocus: true
    }) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "button",
      tabIndex: 0,
      className: optionButtonClass(isSelected),
      onClick: function onClick() {
        if (!isSelected) choose({
          kind: "custom",
          text: startingText
        });
      },
      "data-sentry-component": "renderCustomOption",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex-1",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-[#686766]",
          children: "Write my own"
        }), customEditor]
      })
    });
  }
  function renderZoneStep(zone) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1.5",
      "data-sentry-component": "renderZoneStep",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: [renderZoneContext(zone), zone.options.filter(function (option) {
        var _cardOf6;
        return (_cardOf6 = cardOf(option.cardId)) === null || _cardOf6 === void 0 ? void 0 : _cardOf6.isApplied;
      }).map(function (option) {
        return renderAppliedOption(option.cardId);
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[11px] font-medium text-[#4a5568]",
        children: "Which redline should apply here?"
      }), zone.options.filter(function (option) {
        var _cardOf7;
        return !((_cardOf7 = cardOf(option.cardId)) !== null && _cardOf7 !== void 0 && _cardOf7.isApplied);
      }).map(function (option) {
        return renderCardOption(option.cardId);
      }), renderCombineOption(zone), renderOriginalOption(zone), renderCustomOption(zone)]
    });
  }
  function decisionLabelOf(decision) {
    var _cardOf$cardNumber4, _cardOf8;
    if (decision === null) return "not chosen";
    if (decision.kind === "original") return "neither";
    if (decision.kind === "custom") return "your text";
    return "#".concat((_cardOf$cardNumber4 = (_cardOf8 = cardOf(decision.cardId)) === null || _cardOf8 === void 0 ? void 0 : _cardOf8.cardNumber) !== null && _cardOf$cardNumber4 !== void 0 ? _cardOf$cardNumber4 : "?");
  }
  function renderDecisionSummary(zone, decision, position) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      className: "text-[11px] text-[#686766]",
      "data-sentry-component": "renderDecisionSummary",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: [zone.originalText ? "\"".concat(zone.originalText, "\"") : "Added text", ": ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#4a5568] font-medium",
        children: decisionLabelOf(decision)
      })]
    }, position);
  }
  var reviewStep = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1.5",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[11px] font-medium text-[#4a5568]",
      children: "The paragraph will read"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "bg-[#F8F6F3] border border-[#E5E2DD] rounded px-2 py-1.5",
      children: resolutionPreview === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLiveChange.CardLiveChange, {
        preview: resolutionPreview,
        signedInAuthorName: signedInAuthorName,
        blockLimit: null,
        applied: false
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "list-none p-0 m-0 flex flex-col gap-0.5",
      children: openZones.map(function (zone, position) {
        return renderDecisionSummary(zone, decisions[position], position);
      })
    })]
  });
  var stepBody = currentZone === null ? reviewStep : renderZoneStep(currentZone);
  function renderPrimaryButton() {
    if (isSinglePart) {
      return (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) === "custom" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        disabled: isApplying,
        onClick: applyAll,
        className: primaryButtonClass,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 13,
          height: 13
        }), isApplying ? "Applying…" : "Apply my text"]
      }) : null;
    }
    if (isReviewStep) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        disabled: !everyZoneDecided || isApplying,
        onClick: applyAll,
        className: primaryButtonClass,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 13,
          height: 13
        }), isApplying ? "Applying…" : "Apply resolution"]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      disabled: currentDecision === null,
      onClick: function onClick() {
        return setStepIndex(stepIndex + 1);
      },
      className: primaryButtonClass,
      "data-sentry-component": "renderPrimaryButton",
      "data-sentry-source-file": "ConflictResolver.tsx",
      children: "Next"
    });
  }
  var primaryButton = renderPrimaryButton();
  var backButton = isSinglePart ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    onClick: goBack,
    className: "px-3 h-[22px] rounded text-[11px] text-primary bg-white border border-primary cursor-pointer",
    children: "Back"
  });
  var applyingNote = isSinglePart && isApplying && (currentDecision === null || currentDecision === void 0 ? void 0 : currentDecision.kind) !== "custom" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "text-[11px] text-[#686766]",
    children: "Applying\u2026"
  }) : null;
  var footer = primaryButton === null && backButton === null && applyingNote === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex-shrink-0 flex items-center justify-between gap-2 pt-1.5 border-t border-[#E5E2DD]",
    children: [backButton !== null && backButton !== void 0 ? backButton : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), applyingNote, primaryButton]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "h-full flex flex-col gap-2",
    "data-sentry-component": "ConflictResolver",
    "data-sentry-source-file": "ConflictResolver.tsx",
    children: [header, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1 min-h-0 overflow-y-auto pr-0.5",
      children: stepBody
    }), footer]
  });
};